import styled from 'styled-components';
import { Card } from 'components/card';
import { ChevronRight } from 'lucide-react';

export const StyledResultCard = styled(Card).attrs({
  className:
    'cursor-pointer hover:shadow-md transition-shadow focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 flex flex-col px-3 py-2 gap-2',
})``;

export const CardHeader = styled.div.attrs({
  className: 'flex flex-row items-center justify-between w-full text-xs leading-4',
})``;

export const CardInfo = styled.div.attrs<{ $isError?: boolean }>(({ $isError }) => ({
  className: `flex flex-row items-center space-x-1 ${$isError ? 'text-red-500' : 'text-muted-foreground'}`,
}))<{ $isError?: boolean }>``;

export const StatusContainer = styled.div.attrs({
  className: 'flex items-center space-x-2',
})``;

export const StatusIconContainer = styled.div.attrs({
  className: 'flex items-center justify-center w-4 h-4',
})``;

export const ChevronRightIcon = styled(ChevronRight).attrs({
  className: 'h-4 w-4 text-muted-foreground',
})``;
